import Vue from 'vue';
import VueRouter from 'vue-router';
import routes from './routes';
import store from "../store";
import Notifications from "../components/NotificationPlugin";

Vue.use(VueRouter);
Vue.use(Notifications);


// configure router
const router = new VueRouter({
    routes, // short for routes: routes
    linkActiveClass: 'active',
    mode: 'history'
});


router.beforeEach((to, from, next) => {
        if (store.getters.isAdmin) {
            next();
        }

        if (store.getters.isOldUserBilling && to.name === 'Billing') {
            next();
        }

        if (store.getters.isAuthenticated && localStorage.getItem('permissions') === 'teacher' && localStorage.getItem('teacher')) {
            if (to.meta.permission === 'teacher') {
                next();
            } else {
                next('/school/classroom/' + localStorage.getItem('teacher'));
            }
        }

        if (to.matched.some((record) => record.meta.requiredAuth) && store.getters.isAuthenticated === false) {
            next({
                path: '/login',
                query: {redirect: to.fullPath}
            });
        }

        if (to.matched.some(record => record.meta.permission) === false) {
            next();
        }

        if (to.meta.permission !== null || to.meta.permission != undefined) {
            store.dispatch('customer/getPermissions').then((resp) => {
                if (to.meta.permission === 'teacher') {
                    next();
                }

                if (resp.includes(to.meta.permission)) {
                    next()
                } else {
                    // next('/logout');
                }
            }).catch(() => next('/login'));
        }

    }
);


export default router;
